<sd-4-5-1-dialog #dialog open="true" (sd-after-hide)="close()">
  <div
    class="sd-headline sd-headline--size-3xl"
    slot="headline">
    {{ titleI18n | transloco }}
  </div>

  <form #form (submit)="checkValidity()">
    @for (inputGroup of inputConfig.inputGroups; track $index) {
      <div class="sd-leadtext sd-leadtext--size-lg">
        {{ inputGroup.titleI18n | transloco }}
      </div>

      @for (inputField of inputGroup.inputs; track inputField.key) {
        <sd-4-5-1-input
          #input
          size="md"
          [(wctSdModel)]="state[inputField.key]"
          [type]="inputField.type ?? 'text'"
          [attr.key]="inputField.key"
          [attr.style-on-valid]="!inputField.readonly ? true : null"
          [attr.disabled]="loading() ? true : null"
          [attr.readonly]="inputField.readonly ? true : null"
          [attr.required]="(!inputField.readonly && inputField.required) ? true : null"
          [attr.inputmode]="inputField.mode ?? 'text'">
          <span
            slot="label"
            class="sd-meta sd-meta--size-sm sd-meta--light">
            {{ inputField.i18n | transloco }}
          </span>
          @if (inputField.key === 'mailAddress' && eMailDomain.length > 0) {
            <span
              wctSuffix
              [inputElement]="input"
              slot="right"
              class="sd-meta sd-meta--light suffix">
              &commat;{{ eMailDomain }}
            </span>
          }
        </sd-4-5-1-input>
      }

      @if (!$last) {
        <wct-spacer />
      }
    }
  </form>

  <div
    slot="footer"
    class="button-row">
    <sd-4-5-1-button
      variant="secondary"
      (click)="dialog.hide()"
      [attr.disabled]="loading() ? true : null">
      {{ 'general.cancel' | transloco }}
    </sd-4-5-1-button>

    <sd-4-5-1-button
      (click)="save()"
      [attr.loading]="loading() ? true : null">
      {{ saveI18n | transloco }}
    </sd-4-5-1-button>
  </div>
</sd-4-5-1-dialog>
